import {
  LIMITED_TIME_SPECIAL,
  LAST_ACT,
  CLEARANCE,
  TODAY_ONLY,
  BLACK_FRIDAY_DEAL,
  CYBER_MONDAY_DEAL,
  LOWEST_PRICE_OF_THE_SEASON,
  WITH_CODE,
} from '../../price/constants';

export const SHOP_MORE_URL_MAP_BY_PROMO_TYPE = {
  [LIMITED_TIME_SPECIAL]: 'Special_offers/Limited-Time%20Special',
  [LAST_ACT]: 'Special_offers/Last%20Act',
  [CLEARANCE]: 'Special_offers/Clearance',
  [TODAY_ONLY]: 'Special_offers/Today%20Only',
  [BLACK_FRIDAY_DEAL]: 'Special_offers/Black%20Friday%20Deal',
  [CYBER_MONDAY_DEAL]: 'Special_offers/Cyber%20Monday%20Deal',
  [LOWEST_PRICE_OF_THE_SEASON]: 'Special_offers/Our%20Lowest%20Price',
  [WITH_CODE]: 'Special_offers/Offer%20code%20[CODE_PLUG]',
};

export const SHOP_MORE_LABEL_MAP_BY_PROMO_TYPE = {
  [LIMITED_TIME_SPECIAL]: 'Shop more Limited-Time Specials',
  [LAST_ACT]: 'Shop more Last Act',
  [CLEARANCE]: 'Shop more clearance',
  [TODAY_ONLY]: 'Shop more Today Only',
  [BLACK_FRIDAY_DEAL]: 'Shop more Black Friday Deals',
  [CYBER_MONDAY_DEAL]: 'Shop more Cyber Monday Deals',
  [LOWEST_PRICE_OF_THE_SEASON]: 'Shop more Lowest Prices of the Season',
  [WITH_CODE]: 'Shop more with code [CODE_PLUG]',
};
